module.exports = __webpack_public_path__ + "static/media/Logo.eed2f515.png";